var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.777,
    height: 18.004,
    viewBox: "0 0 16.777 18.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16271",
    "data-name": "Group 16271",
    transform: "translate(-10.4 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18986",
    "data-name": "Path 18986",
    d: "M21.761,9.891V7.5h-6.2V9.891H10.4v1.291h1.544l1.1,14.323H24.321l1.1-14.323h1.756V9.891ZM20.491,8.769v1.1H16.853v-1.1ZM14.208,24.192,13.214,11.16h10.9L23.094,24.192Z",
    transform: "translate(0 0)",
    fill: "#e0272b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4938",
    "data-name": "Rectangle 4938",
    width: 1.291,
    height: 9.372,
    transform: "translate(18.016 13.022)",
    fill: "#e0272b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4939",
    "data-name": "Rectangle 4939",
    width: 9.393,
    height: 1.29,
    transform: "translate(20.388 22.363) rotate(-86.892)",
    fill: "#e0272b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4940",
    "data-name": "Rectangle 4940",
    width: 1.29,
    height: 9.393,
    transform: "matrix(0.999, -0.054, 0.054, 0.999, 15.136, 13.054)",
    fill: "#e0272b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.1d64649c2728cb766afa421e137823bf.svg";
export { ForwardRef as ReactComponent };